var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("actions",null,{"loading":_vm.downloading,"on":_vm.download})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }